export default [
  {
    path: '/activity-20260410-noble-hifun-week',
    component: () => import('./Page.vue'),
    meta: { title: '贵族嗨翻周' },
  },
]
